import React from 'react';
import '../template-file-css/document-file-template.css';



export const LHH_ClientEntryForm = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='LHH_ClientEntryForm' className='file-pdf-document'>
            <div className='file-template'>


                <p className='w-750'><h3>Individual Profile/Face Sheet (Client Entry Form for WITS)</h3></p>

                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Agency</span>
                            <input type='text' name='txtAgency' id='txtAgency' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Facility</span>
                            <input type='text' name='txtFacility' id='txtFacility' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>First Name</span>
                            <input type='text' name='txtFirstName' id='txtFirstName' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Last Name</span>
                            <input type='text' name='txtLastName' id='txtLastName' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Provider Client ID</span>
                            <input type='text' name='txtProviderClient' id='txtProviderClient' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>DOB</span>
                            <input type='date' name='txtDob' id='txtDob' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>SSN</span>
                            <input type='text' name='txtSsn' id='txtSsn' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Gender</span>
                            <input type='radio' id='rbGender_Yes' name='rbGender' className='add-only' value='1' /> Male &nbsp;
                            <input type='radio' id='rbGender_No' name='rbGender' className='add-only' value='0' /> Female
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Veteran Status:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbVeteran11_Yes' name='rbVeteran11' className='add-only' value='1' /> No
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbVeteran11_Ye' name='rbVeteran11' className='add-only' value='2' /> Not Collected
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbVeteran11_Ys' name='rbVeteran11' className='add-only' value='3' /> Unknown
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbVeteran11_No' name='rbVeteran11' className='add-only' value='4' /> Yes
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Ethnicity</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbEthnicity_Yesr' name='rbEthnicity' className='add-only' value='1' /> Puerto Rican
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbEthnicity_Ye1' name='rbEthnicity' className='add-only' value='2' /> Mexican
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbEthnicity_Ys1' name='rbEthnicity' className='add-only' value='3' /> Cuban
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbEthnicity_No1' name='rbEthnicity' className='add-only' value='4' /> Other specific Hispanic
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbEthnicity_Yt1' name='rbEthnicity' className='add-only' value='5' /> Unknown
                        </td>
                        <td className='w-350'>
                            <input type='radio' id='rbEthnicity_Yu1' name='rbEthnicity' className='add-only' value='6' /> Hispanic or Latino-specific origin not specified
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbEthnicity_Yts' name='rbEthnicity' className='add-only' value='7' /> Not Hispanic or Latino
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Race</span><span className='small'> (Check One or More)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='chkRace1' id='chkRace1' className='add-only' value='Alaska' />Alaska Native
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='chkRace2' id='chkRace2' className='add-only' value='Sad' />American Indian
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='chkRace3' id='chkRace3' className='add-only' value='Asian' />Asian
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='chkRace4' id='chkRace4' className='add-only' value='Other' />Other Race
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='checkbox' name='chkRace7' id='chkRace7' className='add-only' value='Unknown' />Unknown
                        </td>
                        <td className='w-187'>
                            <input type='checkbox' name='chkRace71' id='chkRace71' className='add-only' value='White' />White
                        </td>
                        <td className='w-375'>
                            <input type='checkbox' name='chkRace5' id='chkRace5' className='add-only' value='Black' />Black or African American
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='checkbox' name='chkRace6' id='chkRace6' className='add-only' value='Native' />Native Hawaiian or Other Pacific Islander
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Citizenship</span>
                    <input type='radio' id='rbCitizenship_Yes' name='rbCitizenship' className='add-only' value='1' /> United States Citizen &nbsp;
                    <input type='radio' id='rbCitizenship_No' name='rbCitizenship' className='add-only' value='0' /> Non United States Citizen
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Address</span>
                            <input type='text' name='txtAddress' id='txtAddress' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>City</span>
                            <input type='text' name='txtCity' id='txtCity' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip</span>
                            <input type='text' name='txtZip' id='txtZip' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Address County</span>
                            <input type='text' name='txtAddressCounty' id='txtAddressCounty' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Address Type</span>
                            <input type='text' name='txtAddressType' id='txtAddressType' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Residence County</span>
                            <input type='text' name='txtZipCounty' id='txtZipCounty' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Sorce of Referral</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol1_Yes' name='rbAlcohol1' className='add-only' value='1' /> Alcohol/Drug Abuse Care Provider
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol1_No' name='rbAlcohol1' className='add-only' value='2' /> Court/County Justice
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol1_Ys' name='rbAlcohol1' className='add-only' value='3' /> Court/Criminal Justice - Diversionary
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol1_Ye' name='rbAlcohol1' className='add-only' value='4' /> Court/Criminal Justice - DUI/DWI
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol1_Ya' name='rbAlcohol1' className='add-only' value='5' /> Court/Criminal Justice - Not Applicable
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol1_Yq' name='rbAlcohol1' className='add-only' value='6' /> Court/Criminal Justice - Not Collected
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol1_Yw' name='rbAlcohol1' className='add-only' value='7' /> Court/Criminal Justice - Other
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol1_Yr' name='rbAlcohol1' className='add-only' value='8' /> Court/Criminal Justice - Other Court
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbAlcohol1_Yy' name='rbAlcohol1' className='add-only' value='9' /> Court/Criminal Justice - Other Recognized Legal Entity
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol1_Yu' name='rbAlcohol1' className='add-only' value='9' /> Court/Criminal Justice - Prison
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol1_Yiw' name='rbAlcohol1' className='add-only' value='10' /> Court/Criminal Justice - Probation/Parole
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol1_Yue' name='rbAlcohol1' className='add-only' value='9' /> Court/Criminal Justice - State/Federal Court
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol1_Yi' name='rbAlcohol1' className='add-only' value='10' /> Court/Criminal Justice - Unknown
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbAlcohol1_Yo' name='rbAlcohol1' className='add-only' value='11' /> Crisis/Respite Program
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbAlcohol1_Yp' name='rbAlcohol1' className='add-only' value='12' /> Employer/EAP
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbAlcohol1_Yl' name='rbAlcohol1' className='add-only' value='13' /> Home
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbAlcohol1_Yk' name='rbAlcohol1' className='add-only' value='14' /> Individual (includes self-referral)
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbAlcohol1_Yj' name='rbAlcohol1' className='add-only' value='15' /> Nursing Home
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbAlcohol1_Yh' name='rbAlcohol1' className='add-only' value='16' /> Other Community Referral
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbAlcohol1_Yg' name='rbAlcohol1' className='add-only' value='17' /> Other Health Care Provider
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbAlcohol1_Yf' name='rbAlcohol1' className='add-only' value='18' /> Other IDD Facility
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbAlcohol1_Ym' name='rbAlcohol1' className='add-only' value='19' /> Personal Care Home
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbAlcohol1_Yn' name='rbAlcohol1' className='add-only' value='20' /> School (Educational)
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbAlcohol1_Yb' name='rbAlcohol1' className='add-only' value='21' /> Veterans Administration (VA)
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbAlcohol1_Yv' name='rbAlcohol1' className='add-only' value='22' /> Unknown
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Initial Contact</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type='radio' id='rbVeteran_Yes' name='rbVeteran' className='add-only' value='1' /> By Appointment
                        </td>
                        <td className='w-225'>
                            <input type='radio' id='rbVeteran_Ye' name='rbVeteran' className='add-only' value='2' /> Community Service Patrol
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbVeteran_No' name='rbVeteran' className='add-only' value='4' /> Phone
                        </td>
                        <td className='w-225'>
                            <input type='radio' id='rbVeteran_Yp' name='rbVeteran' className='add-only' value='5' /> Walk-in
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbVeteran_Ys' name='rbVeteran' className='add-only' value='3' /> Other: &nbsp;
                            <input type='text' name='txtOther' id='txtOther' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Initial Contact Date</span>
                            <input type='date' name='txtContactDate' id='txtContactDate' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Intake Date:</span>
                            <input type='date' name='txtIntakeDate' id='txtIntakeDate' className='add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Pregnant</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbPregnant_Yes' name='rbPregnant' className='add-only' value='1' /> Yes
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbPregnant_Ye' name='rbPregnant' className='add-only' value='2' /> No
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbPregnant_Ys' name='rbPregnant' className='add-only' value='3' /> Not Applicable
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbPregnant_No' name='rbPregnant' className='add-only' value='4' /> Unknown
                        </td>
                    </tr>
                </table>
                <p className='w-750'>Due Date: &nbsp;
                    <input type='date' name='txtDueDate1' id='txtDueDate1' className='add-only w-200 custom-add-only' /></p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>HIV Positive</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbPregnant1_Yes' name='rbPregnant1' className='add-only' value='1' /> Yes
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbPregnant1_Ye' name='rbPregnant1' className='add-only' value='2' /> No
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbPregnant1_Ys' name='rbPregnant1' className='add-only' value='3' /> Unknown
                        </td>
                        <td className='w-187'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Injection Drug User</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbPregnant2_Yes' name='rbPregnant2' className='add-only' value='1' /> Yes
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbPregnant2_Ye' name='rbPregnant2' className='add-only' value='2' /> No
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbPregnant2_Ys' name='rbPregnant2' className='add-only' value='3' /> Unknown
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Presenting Problem</span>
                    <textarea id='txtPresenting' name='txtPresenting' className='add-only'></textarea>
                </p>
                <p className='w-750'>Due Date: &nbsp;
                    <input type='date' name='txtDueDate' id='txtDueDate' className='add-only w-200 custom-add-only' /></p>
                <table>
                    <tr>
                        <td className='w-375'>
                            <span className='eleHeader'>Admission Date</span>
                            <input type='date' name='txtAdmissionDate' id='txtAdmissionDate' className='add-only' />
                        </td>
                        <td className='w-375'>
                            <span className='eleHeader'>Outcome Measure Date</span>
                            <input type='date' name='txtOutcome' id='txtOutcome' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbPregnant3_Yes' name='rbPregnant3' className='add-only' value='1' /> SA
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbPregnant3_Ye' name='rbPregnant3' className='add-only' value='2' /> Mental Health
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbPregnant3_Ys' name='rbPregnant3' className='add-only' value='3' /> IDD
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Codependent/Collateral</span>
                    <input type='radio' id='rbCollateral_Ye' name='rbCollateral' className='add-only' value='1' /> Yes &nbsp;
                    <input type='radio' id='rbCollateral_Yee' name='rbCollateral' className='add-only' value='0' /> No
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Education status</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbAlcohol_Yes' name='rbAlcohol' className='add-only' value='1' /> None, never attended school
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_No' name='rbAlcohol' className='add-only' value='2' /> First grade
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_Ys' name='rbAlcohol' className='add-only' value='3' /> Second grade
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_Ye' name='rbAlcohol' className='add-only' value='4' /> Third grade
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_Ya' name='rbAlcohol' className='add-only' value='5' /> Fourth grade
                        </td>
                    </tr>

                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_Yq2' name='rbAlcohol' className='add-only' value='6' /> Fifth grade
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_Yw2' name='rbAlcohol' className='add-only' value='7' /> Sixth grade
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_Yr2' name='rbAlcohol' className='add-only' value='8' /> Seventh grade
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_Yy' name='rbAlcohol' className='add-only' value='9' /> Eighth grade
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_Yu' name='rbAlcohol' className='add-only' value='9' /> Ninth grade
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_Yi2' name='rbAlcohol' className='add-only' value='10' /> Tenth grade
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_Yu5' name='rbAlcohol' className='add-only' value='91' /> Eleventh grade
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_Yo' name='rbAlcohol' className='add-only' value='11' /> One Year of College
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol_Yi' name='rbAlcohol' className='add-only' value='101' /> Twelfth grade, High School Graduate or GED
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol_Yp' name='rbAlcohol' className='add-only' value='12' /> Tow Year of College or Associate's Degree
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_Yl' name='rbAlcohol' className='add-only' value='13' /> Three Years of College
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_Yk' name='rbAlcohol' className='add-only' value='14' /> Bachelor's Degree
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol_Yj' name='rbAlcohol' className='add-only' value='15' /> Some Post Graduate Study
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_Yh' name='rbAlcohol' className='add-only' value='16' /> Master's Degree
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_Yf' name='rbAlcohol' className='add-only' value='18' /> Technical trade school
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_Ym' name='rbAlcohol' className='add-only' value='19' /> Kindergarten
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol_Yb' name='rbAlcohol' className='add-only' value='21' /> Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbAlcohol_Yg' name='rbAlcohol' className='add-only' value='17' /> Graduate or Professional School - Doctoral Study, Med School, Law School, etc.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbAlcohol_Yn' name='rbAlcohol' className='add-only' value='20' /> Special Education Class
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Employment Status</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol2_Yest' name='rbAlcohol2' className='add-only' value='1' /> Full Time
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol2_No4' name='rbAlcohol2' className='add-only' value='2' /> Not in Labor Force- Disabled
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol2_Ys3' name='rbAlcohol2' className='add-only' value='3' /> Not in Labor Force- Homemaker
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol2_Ye4' name='rbAlcohol2' className='add-only' value='4' /> Not in Labor Force- Inmate of Institution
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol2_Ya' name='rbAlcohol2' className='add-only' value='5' /> Not in Labor Force- Not Collected
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol2_Yq' name='rbAlcohol2' className='add-only' value='6' /> Not in Labor Force- Other
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol2_Yw' name='rbAlcohol2' className='add-only' value='7' /> Not in Labor Force- Retired
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol2_Yr' name='rbAlcohol2' className='add-only' value='8' /> Not in Labor Force- Student
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol2_Yy' name='rbAlcohol2' className='add-only' value='9' /> Not in Labor Force- Unknown
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol2_Yu' name='rbAlcohol2' className='add-only' value='10' /> Part Time
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol2_Yua' name='rbAlcohol2' className='add-only' value='11' /> Unemployed
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbAlcohol2_Yia' name='rbAlcohol2' className='add-only' value='12' /> Unknown
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Living Situation</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbLivingSituation_Yes' name='rbLivingSituation' className='add-only' value='1' /> Dependent Living
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbLivingSituation_No' name='rbLivingSituation' className='add-only' value='2' /> Homeless
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbLivingSituation_Ys' name='rbLivingSituation' className='add-only' value='3' /> Independent Living
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbLivingSituation_Ye' name='rbLivingSituation' className='add-only' value='4' /> Unknown
                        </td>
                    </tr>
                </table>

                <p className='w-750'>
                    <span className='eleHeader'>Is Client Indigent</span> &nbsp;
                    <input type='radio' id='rbClientIndigent_Ye' name='rbClientIndigent' className='add-only' value='4' /> Yes &nbsp;
                    <input type='radio' id='rbClientIndigent_No1' name='rbClientIndigent' className='add-only' value='5' /> No
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'># of Arrests in Past 30 Days</span>
                            <input type='text' name='txtArrests' id='txtArrests' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Program</span>
                            <input type='text' name='txtProgram' id='txtProgram' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Program Start Date</span>
                            <input type='date' name='txtProgramStartDate' id='txtProgramStartDate' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Primary Diagnosis</span>
                    <textarea id='txtPrimary1' name='txtPrimary1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Tertiary Diagnosis</span>
                    <textarea id='txtTertiary1' name='txtTertiary1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Secondary Diagnosis</span>
                    <textarea id='txtSecondary11' name='txtSecondary1' className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <b>Days on Wait List: </b> &nbsp;
                    <input type='text' name='txtWait' id='txtWait' className='add-only w-250 custom-add-only' />
                </p>

                <p className='w-750'><h4>Mental Health:</h4></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>SMI/SED Status</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbAlcohol3_Yes' name='rbAlcohol3' className='add-only' value='1' /> At risk for SED (optional)
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbAlcohol3_No' name='rbAlcohol3' className='add-only' value='2' /> Not SMI or SED
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbAlcohol3_Ys' name='rbAlcohol3' className='add-only' value='3' /> SED
                        </td>
                        <td className='w-100'>
                            <input type='radio' id='rbAlcohol3_Ye1' name='rbAlcohol3' className='add-only' value='4' /> SMI
                        </td>
                        <td className='w-150'>
                            <input type='radio' id='rbAlcohol3_Ye4' name='rbAlcohol3' className='add-only' value='5' /> Unknown
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Mental Health Legal Status</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran1_Yes' name='rbVeteran1' className='add-only' value='1' /> Involuntary- civil
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran1_Ye' name='rbVeteran1' className='add-only' value='2' /> Involuntary- civil, sexual
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran1_Ys' name='rbVeteran1' className='add-only' value='3' /> Involuntary- Crimal
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran1_No' name='rbVeteran1' className='add-only' value='4' /> Involuntary- Juvenile Justice
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran1_Yr' name='rbVeteran1' className='add-only' value='5' /> Not Applicable
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran1_Yt11' name='rbVeteran1' className='add-only' value='6' /> Not Collected
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran1_Yu4' name='rbVeteran1' className='add-only' value='7' /> Unknown
                        </td>
                        <td className='w-500'>
                            <input type='radio' id='rbVeteran1_Ni' name='rbVeteran1' className='add-only' value='8' /> Voluntary - others (parents, guardians, etc.)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran1_Yk' name='rbVeteran1' className='add-only' value='5' /> Voluntary - self
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>School Attendance </span><span className='small'>(last 3 months)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbVeteran4_Yes' name='rbVeteran4' className='add-only' value='1' /> Attending School Regularly: 5 Days or Less Absent
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbVeteran4_Ye' name='rbVeteran4' className='add-only' value='2' /> Home Schooled
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbVeteran4_No' name='rbVeteran4' className='add-only' value='3' /> Not Attending School Regularly: 6 Days or
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbVeteran4_Ys' name='rbVeteran4' className='add-only' value='4' /> Not Applicable
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbVeteran4_Yr' name='rbVeteran4' className='add-only' value='5' /> More Absent
                        </td>
                        <td className='w-375'>
                            <input type='radio' id='rbVeteran4_Yt' name='rbVeteran4' className='add-only' value='6' /> Not Available
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>Substance Use Disorder</h4></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Co-Occuring SA and MH Problem</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran5_Yes' name='rbVeteran5' className='add-only' value='1' /> Yes
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran5_Ye' name='rbVeteran5' className='add-only' value='2' /> No
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran5_Yl' name='rbVeteran5' className='add-only' value='3' /> Unknown
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b># of Prior SA Tx Episodes:</b> &nbsp;
                    <input type='text' name='txtEpisodes' id='txtEpisodes' className='add-only w-250 custom-add-only' />
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'># of times the client has attended a self-help program in the 30 days preceding the date of reference (admission or discharge) to treatment services. Includes attendance at AA, NA, and other self-help/mutual support groups focused on recovery from substance abuse and dependence.</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran6_Yes' name='rbVeteran6' className='add-only' value='1' /> No attendance in the past month
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran6_Ye' name='rbVeteran6' className='add-only' value='2' /> 1-3 times in past month
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran6_Ys' name='rbVeteran6' className='add-only' value='3' /> 4-7 times in past month
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran6_No' name='rbVeteran6' className='add-only' value='4' /> 8-15 times in past month
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran6_Yr' name='rbVeteran6' className='add-only' value='5' /> 16-30 times in past month
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran6_Ylo' name='rbVeteran6' className='add-only' value='7' /> Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbVeteran6_Yt' name='rbVeteran6' className='add-only' value='6' /> Some attendance in past month, but frequency unknown
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Medication Assisted Tx</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol4_Yes' name='rbAlcohol4' className='add-only' value='1' /> Yes
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol4_No' name='rbAlcohol4' className='add-only' value='2' /> No
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol4_Ys' name='rbAlcohol4' className='add-only' value='3' /> Unknwon
                        </td>
                        <td className='w-187'>
                            <input type='radio' id='rbAlcohol4_Ye' name='rbAlcohol4' className='add-only' value='4' /> Not Applicable
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Source of Income</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran7_Yes' name='rbVeteran7' className='add-only' value='1' /> Disability
                        </td>
                        <td className='w-200'>
                            <input type='radio' id='rbVeteran7_Ye' name='rbVeteran7' className='add-only' value='2' /> None
                        </td>
                        <td className='w-750'>
                            <input type='radio' id='rbVeteran7_Yt' name='rbVeteran7' className='add-only' value='6' /> Wages/Salary
                        </td>
                    </tr>

                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran7_No' name='rbVeteran7' className='add-only' value='4' /> Public Assistance
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran7_Yr' name='rbVeteran7' className='add-only' value='5' /> Retirement/Pension
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran7_Ylo' name='rbVeteran7' className='add-only' value='7' /> Unknown
                        </td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbVeteran7_Ys' name='rbVeteran7' className='add-only' value='3' /> Other: &nbsp;
                            <input type='text' name='txtOtherWeig' id='txtOtherWeig' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Health Insurance</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbVeteran9_Yes' name='rbVeteran9' className='add-only' value='1' /> Blue Cross/Blue Shield
                        </td>
                        <td className='w-300'>
                            <input type='radio' id='rbVeteran9_Ye' name='rbVeteran9' className='add-only' value='2' /> Health Maintenance Organization (HMO)
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran9_Ys' name='rbVeteran9' className='add-only' value='3' /> Medicaid
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbVeteran9_No' name='rbVeteran9' className='add-only' value='4' /> Medicare
                        </td>
                        <td className='w-300'>
                            <input type='radio' id='rbVeteran9_Yr' name='rbVeteran9' className='add-only' value='5' /> None
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran9_Ylo' name='rbVeteran9' className='add-only' value='7' /> Other (e.g., Tricare, Champus)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbVeteran9_Yt' name='rbVeteran9' className='add-only' value='6' /> Private Insurance
                        </td>
                        <td className='w-500'>
                            <input type='radio' id='rbVeteran9_Ytk' name='rbVeteran9' className='add-only' value='8' /> Unknown
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Primary Payment Source</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran19_Yes' name='rbVeteran19' className='add-only' value='1' /> Blue Cross/Blue Shield
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran19_Ye' name='rbVeteran19' className='add-only' value='2' /> Medicaid
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran19_Ys' name='rbVeteran19' className='add-only' value='3' /> Medicare
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran19_No' name='rbVeteran19' className='add-only' value='4' /> No Change
                        </td>
                        
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran19_Ylo' name='rbVeteran19' className='add-only' value='7' /> Other Government Payments
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran19_Yt5' name='rbVeteran19' className='add-only' value='9' /> Unknown
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran19_Yt' name='rbVeteran19' className='add-only' value='6' /> Other Heath Insurance Companies
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran19_Ytk' name='rbVeteran19' className='add-only' value='8' /> Self-pay
                        </td>
                    </tr>
                    <tr>
                    <td className='w-750'>
                            <input type='radio' id='rbVeteran19_Yr' name='rbVeteran19' className='add-only' value='5' /> Other: &nbsp;
                            <input type='text' name='txtOtherWeight' id='txtOtherWeight' className='add-only w-350 custom-add-only' />
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Marital Status</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbVeteran29_Yes' name='rbVeteran29' className='add-only' value='1' /> Divorced
                        </td>
                        <td className='w-300'>
                            <input type='radio' id='rbVeteran29_Ye' name='rbVeteran29' className='add-only' value='2' /> Never Married
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran29_Ys' name='rbVeteran29' className='add-only' value='3' /> Now Married
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'>
                            <input type='radio' id='rbVeteran29_No' name='rbVeteran29' className='add-only' value='4' /> Separated
                        </td>
                        <td className='w-300'>
                            <input type='radio' id='rbVeteran29_Yr' name='rbVeteran29' className='add-only' value='5' /> Unknown
                        </td>
                        <td className='w-250'>
                            <input type='radio' id='rbVeteran29_Ylo' name='rbVeteran29' className='add-only' value='7' /> Widowed
                        </td>
                    </tr>
                </table>

                <p className='w-750'><h4>See options below and complete for each substance:</h4></p>

                <table>
                    <tr>
                        <td className='w-100'>&nbsp;
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Substance</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Frequency</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Method</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Detailed Drug Code</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>Primary
                        </td>
                        <td className='w-200'>
                            <input type='text' name='txtSubstance' id='txtSubstance' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' name='txtFrequency' id='txtFrequency' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtMethod' id='txtMethod' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' name='txtDetailed' id='txtDetailed' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>Secondary
                        </td>
                        <td className='w-200'>
                            <input type='text' name='txtSubstance2' id='txtSubstance2' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' name='txtFrequency2' id='txtFrequency2' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtMethod2' id='txtMethod2' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' name='txtDetailed2' id='txtDetailed2' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>Tertiary
                        </td>
                        <td className='w-200'>
                            <input type='text' name='txtSubstance3' id='txtSubstance3' className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' name='txtFrequency3' id='txtFrequency3' className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' name='txtMethod3' id='txtMethod3' className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' name='txtDetailed3' id='txtDetailed3' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    At what age did the client FIRST use the substances indicated above (if unknown, enter 97)
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Primary</span>
                            <input type='text' name='txtPrimary' id='txtPrimary' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Secondary</span>
                            <input type='text' name='txtSecondary' id='txtSecondary' className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Tertiary</span>
                            <input type='text' name='txtTertiary' id='txtTertiary' className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Substance</b><span className='small'>(Type one of these options above)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>None</td>
                        <td className='w-375'>Other Stimulants</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Alcohol</td>
                        <td className='w-375'>Benzodiazepines</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Cocaine/Crack</td>
                        <td className='w-375'>Other Non-Benzodiazepine Tranquilizers</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Marijuana/Hashish/THC Heroin</td>
                        <td className='w-375'>Barbiturates</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Other Hallucinogens Methamphetamine</td>
                        <td className='w-375'>Over-the-Counter</td>
                    </tr>
                    
                    <tr>
                        <td className='w-375'>Other AMphetamines</td>
                        <td className='w-375'>Other</td>
                    </tr>
                    <tr>
                        <td className='w-750'>Non-Prescription Methadone Other Opiates and Synthetics PCP</td>
                    </tr>
                    <tr>
                        <td className='w-750'>Other Non-Barbiturates Sedatives or Hypnotics Inhalants</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Unknown</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Frequency</b><span className='small'>(Type one of these options above)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>No use in the past month</td>
                        <td className='w-375'>1-3 times in the past month</td>
                    </tr>
                    <tr>
                        <td className='w-375'>1-2 times in the past week</td>
                        <td className='w-375'>3-6 times in the past week</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Daily</td>
                        <td className='w-375'>N/A</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Unknown</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Method</b><span className='small'>(Type one of these options above)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>Oral</td>
                        <td className='w-375'>Smoking</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Inhalation</td>
                        <td className='w-375'>Injection (IV or Intramuscular)</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Other</td>
                        <td className='w-375'>N/A</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Unknown</td>
                    </tr>
                </table>
                <p className='w-750'>
                    <b>Detailed Drug Code</b><span className='small'>(Type one of these options above)</span>
                </p>
                <table>
                    <tr>
                        <td className='w-375'>Alcohol</td>
                        <td className='w-375'>Crack</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Other Cocaine</td>
                        <td className='w-375'>Marijuana/Hashish</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Heroin</td>
                        <td className='w-375'>Non-Prescripation Methadone</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Codeine</td>
                        <td className='w-375'>Propoxyphene (Daryon)</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Oxycodone (Oxycotin)</td>
                        <td className='w-375'>Hydromorphone (Dilaudid)</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Meperidine (Demerol)</td>
                        <td className='w-375'>Other Opiates or Synthetics</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Pentazocine (Talwin)</td>
                        <td className='w-375'>Hydrocodone (Vicodin)</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Tramadol (Ultram)</td>
                        <td className='w-375'>Buprenorphine</td>
                    </tr>
                    <tr>
                        <td className='w-375'>LSD</td>
                        <td className='w-375'>PCP or PCP Combination</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Other Hallucinogens</td>
                        <td className='w-375'>Methampetamine/Speed</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Amphetamine</td>
                        <td className='w-375'>Other Amphetamines</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Other Stimulants</td>
                        <td className='w-375'>Methylphenidate (Ritalin)</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Methylenedioxymethamphetamine (MDMA, Ecstasy)</td>
                        <td className='w-375'>Alprazolam (Xanax)</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Chordiazepoxide (Librium)</td>
                        <td className='w-375'>Clorazepate (Tranxene)</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Diazepam (Valium)</td>
                        <td className='w-375'>Flulurazepam (Dalmane)</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Lorazepam (Ativan)</td>
                        <td className='w-375'>Triazolam (Halcion)</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Other Benzodiazepines</td>
                        <td className='w-375'>Flunitrazepam (Rohypnol)</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Meprobamate (Miltown)</td>
                        <td className='w-375'>Other Tranzuilizers</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Clonzazepam (Klonopin, Rivotril)</td>
                        <td className='w-375'>Phenobarbital</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Secobarbital (Seconal)</td>
                        <td className='w-375'>Secobarbital/Amobarbital (Tuinal)</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Other Barbiturate Sedatives</td>
                        <td className='w-375'>Ethchlorvynol (Placidyl)</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Glutethimide (Doriden)</td>
                        <td className='w-375'>Methazualone</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Other Sedatives</td>
                        <td className='w-375'>Other Non-Barbiturate Sedatives</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Arrosols</td>
                        <td className='w-375'>Nitrites</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Other Inhalants</td>
                        <td className='w-375'>Solvents</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Anesthetics</td>
                        <td className='w-375'>Diphenhydramine</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Other Over-the-Counter</td>
                        <td className='w-375'>Diphenylhydantoin/Phenytoin (Dilantin)</td>
                    </tr>
                    <tr>
                        <td className='w-375'>Other Drugs</td>
                        <td className='w-375'>Ketamine (Special K)</td>
                    </tr>
                    <tr>
                        <td className='w-750'>GHB/GBL (Gamma-Hydroxybutyrate, Gamma-Butyrolactone)</td>
                    </tr>
                </table>


            </div>
        </form >

    )
}











